import { swiper, swiperSlide } from 'vue-awesome-swiper';
import messages from './banner-slider-translations';
import { SharedService } from '../../../shared/services/sharedService';

export default {
    name: 'bannerSlider',
    i18n: {
        messages,
    },
    data() {
        return {
            swiperOption: {
                notNextTick: true,
                grabCursor: false,
                setWrapperSize: true,
                autoHeight: true,
                allowSwipeToPrev: true,
                allowSwipeToNext: true,
                autoplay: 5000,                
                speed: 1000,
                fadeEffect: {
                    crossFade: true
                },
                // pagination: '.swiper-pagination',
                // paginationClickable: true,
                // prevButton: '.swiper-button-prev',
                // nextButton: '.swiper-button-next',
            },
        };
    },
    components: {
        swiper,
        swiperSlide,
    },
    filters: {
        dateFormat: (value) => SharedService.dateFormat(value),
        dateDay: (value) => SharedService.dateDay(value),
        dateMonth: (value, lang) => SharedService.dateMonth(value, lang),
        dateYear: (value) => SharedService.dateYear(value),
        truncate: (value, length) => SharedService.truncateText(value, length),
    },
    computed: {
        slideToShow: function () {
            //return Math.floor(Math.random() * 4) + 1;
            return 1;
        },
    },
    props: {
        selectedLang: { type: String },
    },
};



// WEBPACK FOOTER //
// ./src/home-euroregio/components/banner-slider/banner-slider.js